import { Box, DataTableAction, DataTableLabel, Flex, Link, Text } from '@optiaxiom/react';

import { CustomIcon } from '@frontend/components/ui';
import { UnifiedAgent } from '@frontend/types/agent';

type NameCellProps = {
  agent: UnifiedAgent;
  onClick: (agent: UnifiedAgent) => void;
};

export const NameCell = ({ agent, onClick }: NameCellProps) => {
  return (
    <Flex flexDirection="column" gap="4" alignItems="start">
      <DataTableLabel asChild>
        <DataTableAction overflow="hidden" primary>
          <Link appearance="subtle" href="data:," onClick={() => onClick(agent)}>
            <Flex gap="6" flexDirection="row">
              <Text>{agent.name}</Text>
              {agent.is_system_agent && agent.is_installed && (
                <Box>
                  <CustomIcon name="optimizely" height="12" />
                </Box>
              )}
            </Flex>
          </Link>
        </DataTableAction>
      </DataTableLabel>
      <Text fontSize="sm" color="fg.tertiary">
        @{agent.agent_id}
      </Text>
    </Flex>
  );
};
